<agpr-take-over-panel
    [id]="id"
    [header]="settingUpReplay ? ('Social.agentWidget.replay.heading' | localize : {name: agent?.name}) : headerTitle"
    [subHeader]="settingUpReplay ? 'Social.agentWidget.replay.subHeader' : ''"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="closeDialog(true)"
    (closeTakeover)="agentChanged()"
    [width]="showEstimate ? 100 : 80"
    [validateBeforeClose]="showCanLeaveDialog(settingUpReplay)"
    [footerContext]="'Social.intelligence.themeManagement.agent' | localize"
    [formGroup]="agentForm"
    [ariaLabel]="settingUpReplay ? ('Social.agentWidget.replay.heading' | localize : {name: agent?.name}) : headerTitle"
>
    <div
        class="agpr-agentWidget-container"
        [agprLoading]="loading"
    >
        <div class="lhp-container"
            [ngClass]="{
                'lhp--hasEstimate': showEstimate
            }"
        >
            @if (settingUpReplay) {
                <div class="lhp-replay">
                    <label class="agpr-agentWidget-replay-header">
                        {{ 'Social.agentWidget.replay.header' | localize }}
                    </label>

                    <div class="agpr-agentWidget-replay-section">
                        <agpr-radio
                            [id]="id + '_curatedAutoInsightDialog_mentionsInSection'"
                            [label]="'Social.agentWidget.replay.sameAsCurrentTopic'"
                            [hiddenLabel]="'Social.agentWidget.replay.sameAsCurrentTopic'"
                            [tooltip]="'Social.agentWidget.replay.sameAsCurrentTopic.tooltip'"
                            [ngModelOptions]="{standalone: true}"
                            [tooltipPosition]="'right'"
                            [(ngModel)]="isCustomReplay"
                            (ngModelChange)="handleReplayType()"
                            [value]="false"
                        ></agpr-radio>
                        <agpr-radio
                            [id]="id + '_curatedAutoInsightDialog_allSavedMentions'"
                            label="Social.agentWidget.replay.custom"
                            hiddenLabel="Social.agentWidget.replay.custom"
                            [tooltip]="'Social.agentWidget.replay.custom.tooltip'"
                            [ngModelOptions]="{standalone: true}"
                            [tooltipPosition]="'right'"
                            [(ngModel)]="isCustomReplay"
                            (ngModelChange)="handleReplayType()"
                            [value]="true"
                        ></agpr-radio>

                        <div class="agpr-agentWidget-replay-date">
                            <agpr-date-query-popup
                                [id]="id"
                                [(ngModel)]="replayDate"
                                [options]="replayDateFilterOptions"
                                [searchRange]="searchRange"
                                [useToDate]="true"
                                [setEndOfDayTime]="false"
                                [ngModelOptions]="{standalone: true}"
                                [hideDateTypeSelection]="true"
                                [ariaLabelledBy]="id + '-label'"
                            >
                            </agpr-date-query-popup>
                        </div>
                    </div>
                </div>
            }

            <div class="lhp">
                @if (!settingUpReplay) {
                    <agpr-inplace
                        formControlName="name"
                        [id]="id + '.inplace'"
                        class="lhp-inplace"
                        [maxLength]="255"
                        [style]="agprComponentStyle.social"
                        tooltipPosition="left"
                        ariaDescribedBy="name_errors"
                        [ariaInvalid]="name.errors?.['required'] || name.errors?.['duplicateName']"
                    ></agpr-inplace>
                    <ul id="name_errors">
                        <li *ngIf="name.errors?.['duplicateName']">
                            <agpr-form-message>
                                {{ "Social.agentWidget.error.nameExists" | localize }}
                            </agpr-form-message>
                        </li>
                        <li *ngIf="name.errors?.['required']">
                            <agpr-form-message>
                                {{ "Social.agentWidget.error.nameMinLength" | localize }}
                            </agpr-form-message>
                        </li>
                    </ul>
                }

                <agpr-scroll-panel
                    #scrollpanel
                    class="lhpScroll"
                >
                    <ng-container
                        formGroupName="general"
                    >
                        <ng-container
                            formGroupName="section"
                        >
                            <div class="agpr-agentWidget-fieldWrapper">
                                <agpr-network-multi-select
                                    formControlName="networks"
                                    [id]="id + '.network.multiSelect'"
                                    heading="Social.agentWidget.availableNetworks"
                                    [allDisabledExceptTwitter]="settingUpReplay"
                                    [allowedNetworks]="allowedNetworks"
                                    ariaDescribedBy="noNetwork_error"
                                    [partiallyModeratedNetworks]="partiallyModeratedNetworks"
                                    [unavailableNetworks]="notAllowedNetworks"
                                ></agpr-network-multi-select>
                                <agpr-form-message
                                    *ngIf="networks.errors?.['required']"
                                    id="noNetwork_error"
                                >
                                    {{ "Social.agentWidget.error.noNetwork" | localize }}
                                </agpr-form-message>
                            </div>

                            @if (settingUpReplay) {
                                <agpr-message
                                    [severity]="messageSeverities.warning"
                                >
                                    {{ 'Social.agentWidget.replay.onlyAllowX' | localize }}
                                </agpr-message>
                            }

                            <div class="lhpInputGroup">
                                <agpr-include-exclude-chips
                                    formControlName="keywords"
                                    [id]="id + '.keywords.includeExclude'"
                                    class="lhp-include"
                                    caretTooltip="Social.agentWidget.keywords.expandToolTip"
                                    headerLabel="Social.agentWidget.keywords"
                                    placeholder="Social.agentWidget.keywords.placeholder"
                                    [disabled]="agentForm.disabled"
                                    [chipValidations]="[minLengthValidation, mustNotBeOperator]"
                                    [style]="agprComponentStyle.social"
                                    [splitOnPattern]="splitOnPattern"
                                    tooltip="Social.agentWidget.keywords.tooltip"
                                    ariaDescribedBy="keyword_errors"
                                ></agpr-include-exclude-chips>
                                <ul
                                    id="keyword_errors"
                                    class="keywordError"
                                >
                                    <li *ngIf="general.errors?.['noHandleAndKeyword'] && (keywords.touched || handles.touched)">
                                        <agpr-form-message>
                                            {{ "Social.agentWidget.error.keywordOrHandle" | localize }}
                                        </agpr-form-message>
                                    </li>
                                    <li *ngIf="section.errors?.['invalidCharKeywordTwitter']">
                                        <agpr-form-message>
                                            {{ "Social.agentWidget.error.keyword.invalidCharacter.twitter" | localize }}
                                        </agpr-form-message>
                                    </li>
                                    <li *ngIf="keywords.errors?.['invalidCharKeyword']">
                                        <agpr-form-message>
                                            {{ "Social.agentWidget.error.keyword.invalidCharacter" | localize }}
                                        </agpr-form-message>
                                    </li>
                                    <li *ngIf="keywords.errors?.['hashtagSymbol']">
                                        <agpr-form-message>
                                            {{ "Social.agentWidget.error.keyword.hashtag" | localize }}
                                        </agpr-form-message>
                                    </li>
                                    <li *ngIf="keywords.errors?.['onlyNotKeywords']">
                                        <agpr-form-message>
                                            {{ "Social.agentWidget.error.onlyNotKeywords" | localize }}
                                        </agpr-form-message>
                                    </li>
                                    <li *ngIf="keywords.errors?.['maxKeyword']">
                                        <agpr-form-message>
                                            {{ "Social.agentWidget.error.keywordMaximum" | localize }}
                                        </agpr-form-message>
                                    </li>
                                    <li *ngIf="agent?.isModeratedForKeywords">
                                        <agpr-form-message>
                                            {{ "Social.agentWidget.error.moderateKeywords" | localize }}
                                        </agpr-form-message>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>

                        <div>
                            <div class="lhpRow">
                                <agpr-button
                                    class="lhp-caret"
                                    [style]="buttonTypes.link"
                                    [icon]="
                                        handleExpanded
                                            ? 'fa-solid fa-angle-down'
                                            : 'fa-solid fa-angle-right'
                                    "
                                    tooltipPosition="right"
                                    [expanded]="handleExpanded"
                                    (click)="toggleExpanded()"
                                >
                                    <label class="lhp-subHeading--bold">
                                        {{ "Social.agentWidget.handleChannel" | localize }}
                                    </label>
                                </agpr-button>
                                <span
                                    class="fa-regular fa-circle-info agpr-agentWidget-infoIcon"
                                    role="img"
                                    agprTooltip="Social.agentWidget.handleChannel.tooltip"
                                    tooltipPosition="top"
                                ></span>
                            </div>
                            <div
                                *ngIf="handleExpanded"
                                class="handle-container"
                                formArrayName="handles"
                            >
                                @for (network of handles.controls; track network) {
                                    @switch (network.value.type) {
                                        @case (networkType.twitter) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-x-twitter"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_Twitter'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.twitter"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[twitterValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="twitter_handle_errors"
                                                        [invalidHandles]="network.value.blacklistedHandles"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="twitter_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[mediaSubscriptionMediaType.twitter]?.isModeratedForHandles && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @case (networkType.facebook) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-facebook"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_Facebook'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.facebook"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[facebookValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="facebook_handle_errors"
                                                        [invalidHandles]="network.value.blacklistedHandles"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="facebook_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[networkType.facebook]?.isModeratedForHandles  && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @case (networkType.instagram) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-instagram"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_Instagram'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.instagram"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[instaValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="instagram_handle_errors"
                                                        [invalidHandles]="network.value.blacklistedHandles"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="instagram_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[networkType.instagram]?.isModeratedForHandles && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @case (networkType.youtube) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-youtube"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_Youtube'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.youtube"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[youtubeValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="youtube_handle_errors"
                                                        [invalidHandles]="network.value.blacklistedHandles"
                                                        [caseSensitive]="true"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="youtube_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[networkType.youtube]?.isModeratedForHandles && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @case (networkType.reddit) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-reddit"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_Reddit'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.reddit"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[redditValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="reddit_handle_errors"
                                                        [invalidHandles]="network.value.blacklistedHandles"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="reddit_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[networkType.reddit]?.isModeratedForHandles && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize }}
                                                                {{ "Social.agentWidget.error.moderateHandles.reddit" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @case (networkType.subReddit) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-reddit"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_subReddit'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.subReddit"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[subRedditValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="sub_reddit_handle_errors"
                                                        [invalidHandles]="network.value.blacklistedHandles"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="sub_reddit_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[networkType.reddit]?.isModeratedForHandles && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize }}
                                                                {{ "Social.agentWidget.error.moderateHandles.reddit" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @case (networkType.tiktok) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-tiktok"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_TikTok'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.tiktok"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[tiktokValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="tiktok_handle_errors"
                                                        [invalidHandles]="network.value.blacklistedHandles"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="tiktok_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[networkType.tiktok]?.isModeratedForHandles && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize: { network: 'TikTok' } }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @case (networkType.linkedin) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-linkedin"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_LinkedIn'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.linkedin"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[linkedinValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="linkedin_handle_errors"
                                                        [invalidHandles]="network.value.blacklistedHandles"
                                                        [caseSensitive]="true"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="linkedin_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[networkType.linkedin]?.isModeratedForHandles && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize: { network: 'LinkedIn' } }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @case (networkType.bluesky) {
                                            <div>
                                                <div
                                                    class="handleRow"
                                                    [formGroup]="network"
                                                >
                                                    <span class="fa-brands fa-bluesky"></span>
                                                    <agpr-handles-text-input-chips
                                                        formControlName="handleValues"
                                                        class="handle"
                                                        [id]="id + '_handle_Bluesky'"
                                                        placeholder="Social.agentWidget.handlePlacehoder.bluesky"
                                                        [disabled]="agentForm.disabled"
                                                        [style]="agprComponentStyle.social"
                                                        [chipValidations]="[blueskyValidation, minLengthValidation]"
                                                        [trimQuotes]="true"
                                                        [splitOnPattern]="splitOnPattern"
                                                        ariaDescribedBy="bluesky_handle_errors"
                                                    ></agpr-handles-text-input-chips>
                                                </div>
                                                <ul
                                                    id="bluesky_handle_errors"
                                                    class="handlesError"
                                                >
                                                    @if (agent?.moderatedMediaTypes?.[networkType.bluesky]?.isModeratedForHandles && network.value.handleValues?.length > 0) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.moderateHandles" | localize: { network: 'Bluesky' } }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }

                                                    @if (network.errors?.['duplicateHandle']) {
                                                        <li>
                                                            <agpr-form-message>
                                                                {{ "Social.agentWidget.error.handle.duplicate" | localize }}
                                                            </agpr-form-message>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        }
                                    }
                                }
                            </div>
                        </div>
                    </ng-container>

                    @if (!settingUpReplay) {
                        <div class="agpr-agentWidget-divide"></div>

                        <div class="lhpStatus">
                            <div class="agpr-agentWidget-heading">
                                <label class="lhp-subHeading">
                                    {{ "Social.agentWidget.pendingStatus" | localize }}
                                </label>
                                <span
                                    role="img"
                                    class="fa-regular fa-circle-info agpr-agentWidget-infoIcon"
                                    agprTooltip="Social.agentWidget.pendingStatus.tooltip"
                                    tooltipPosition="top"
                                ></span>
                            </div>
                            <agpr-social-topic-status-switch
                                formControlName="status"
                                [id]="id + '_statusSwitch'"
                                [isPartiallyModerated]="agent?.isPartiallyModerated"
                                [agentName]="agent?.name"
                                [partiallyModeratedTooltip]="'Social.intelligence.themeManagement.themeCard.partiallyModerated' | localize: {
                                    rowName: agent?.name,
                                    moderatedNetworks: agent?.partiallyModeratedNetworks
                                }"
                            ></agpr-social-topic-status-switch>
                            <ul id="status_errors">
                                <li *ngIf="status.errors?.['mustIncludeThemeIfActive']">
                                    <agpr-form-message>
                                        {{ "Social.agentWidget.error.noTheme" | localize }}
                                    </agpr-form-message>
                                </li>
                                <li *ngIf="agent?.isPartiallyModerated">
                                    <agpr-message
                                        class="agpr-agentWidget-moderatedMessage"
                                        [severity]="messageSeverities.error"
                                        [style]="agprComponentStyle.social"
                                    >
                                        {{ "Social.agentWidget.error.moderated" | localize }}
                                        <agpr-button
                                            [style]="buttonTypes.link"
                                            (click)="reactivateAll()"
                                        >
                                            {{ 'Social.agentWidget.reactivateAll.link' | localize}}
                                        </agpr-button>
                                    </agpr-message>
                                </li>
                            </ul>
                        </div>

                        <div class="lhpCol">
                            <label
                                *ngIf="mode === agentWidgetMode.edit; else create"
                                for="createAgentWidget.AddToThemes.dropdown.input"
                                class="lhp-subHeading"
                            >
                                {{ "Social.agentWidget.InTheme" | localize }}
                            </label>
                            <ng-template #create>
                                <label
                                    for="createAgentWidget.AddToThemes.dropdown.input"
                                    class="lhp-subHeading"
                                >
                                    {{ "Social.agentWidget.addToTheme" | localize }}
                                </label>
                            </ng-template>

                            <agpr-dropdown-chips
                                formControlName="themes"
                                [id]="id + '.AddToThemes'"
                                placeholder="Social.agentWidget.addToTheme.placeholder"
                                [optionsFetcher]="themeOptionFetcher"
                                [validationFunction]="validateTheme"
                                (onValidationError)="onThemeError($event)"
                                labelLookupValue="name"
                                labelLookupKey="id"
                                [style]="agprComponentStyle.social"
                                (add)="scrollToBottom()"
                            ></agpr-dropdown-chips>
                        </div>
                    }
                </agpr-scroll-panel>
            </div>
        </div>
        <agpr-right-sidebar
            class="rhp"
            [selectedTabIndex]="selectedTabIndex"
            (selectedTabIndexChange)="selectedTabChange($event)"
        >
            <agpr-tab
                [id]="'agentAdditionalSearchSettings'"
                icon=" fa-screwdriver-wrench"
                [tooltip]="'Social.agentSearchSettings'"
            >
                <agpr-agent-search-settings
                    #agentSearchSettings
                    [agent]="agentSummary"
                    [disableSampleRate]="settingUpReplay"
                    [disabled]="agentForm.disabled"
                    [networks]="networks.value"
                    (change)="setAdditionalSearchSettings($event)"
                ></agpr-agent-search-settings>
            </agpr-tab>
            <agpr-tab
                [id]="'agentSummaryTab'"
                icon=" fa-file-lines"
                [tooltip]="'Social.agentWidget.socialTopicDetails'"
                [disabled]="settingUpReplay"
            >
                <agpr-agent-summary
                    [agent]="agentSummary"
                    [networks]="networks.value"
                    [showDetails]="mode === agentWidgetMode.edit"
                ></agpr-agent-summary>
            </agpr-tab>

            <agpr-tab
                [id]="'estimateTab'"
                icon=" fa-bars-progress"
                [tooltip]="'Social.agentWidget.postEstimate'"
                [disabled]="settingUpReplay"
            >
                <div
                    class="rhp-estimateContainer"
                    [agprLoading]="loadingEstimate"

                >
                    <agpr-scroll-panel class="rhp-scrollPanel">
                        <agpr-message
                            [severity]="messageSeverities.info"
                            [style]="agprComponentStyle.social"
                        >
                            {{ "Social.agentWidget.estimateInfo" | localize }}
                        </agpr-message>
                        <div
                            *ngIf="hasEstimate"
                            class="rhp-row"
                        >
                            <div class="rhp-section rhp-estimateCount">
                                <div class="rhp-estimateCount-content">
                                    <label class="rhp-estimateCountLabel">{{ "Social.agentWidget.estimateUsage" | localize }}</label>
                                    <span class="rhp-estimateCountNumber">{{ estimatedAgentUsageRange }}</span>
                                </div>
                            </div>
                            <div class="rhp-section rhp-estimateProportion">
                                <label class="rhp-estimateProportionLabel">{{ 'Social.agentWidget.estimateUsage.barChartTitle' | localize }}</label>
                                <agpr-chart
                                    [chart]="quotaEstimateChart"
                                ></agpr-chart>
                            </div>
                        </div>
                        <agpr-message
                            *ngIf="!hasEstimate"
                            [severity]="messageSeverities.noContent"
                        >
                            {{ 'Social.agentWidget.estimateUsage.noEstimate' | localize }}
                        </agpr-message>
                        <div class="rhp-heading">
                            <label class="agpr-agentWidget-postViewLabel">
                                {{ "Social.agentWidget.postPreview" | localize }}
                            </label>
                            <span
                                role="img"
                                class="fa-regular fa-circle-info agpr-agentWidget-infoIcon"
                                agprTooltip="Social.agentWidget.estimateUsage.postView.info"
                                tooltipPosition="top"
                            ></span>
                        </div>
                        @if (hasSamplePosts) {
                            <ul
                                [id]="id + '_agentsList'"
                                agprListKeyboardNavigation
                                [list]="mentions"
                                class="agpr-agentWidget-postFeed-container"
                            >
                                <li
                                    *ngFor="let mention of mentions; index as i"
                                    [id]="id + '_agentWidgetSocialPostFeedCard_' + i"
                                    [attr.aria-label]="mention.headline ?
                                        mention.headline :
                                        ('MediaType.'+ mention.mediaType.id | localize) +  ('Mention.postBy' | localize) +  mention.author.name
                                    "
                                >
                                    <agpr-social-post-feed-card
                                        [mention]="mention"
                                        [showImages]="false"
                                    ></agpr-social-post-feed-card>
                                </li>
                            </ul>
                        }
                        <agpr-message
                            *ngIf="!hasSamplePosts"
                            [severity]="messageSeverities.noContent"
                        >
                            {{ (hasEstimate ?
                                'Social.agentWidget.estimateUsage.noSamplePosts.general'
                                : 'Social.agentWidget.estimateUsage.noSamplePosts.twitter'
                            ) | localize }}
                        </agpr-message>
                    </agpr-scroll-panel>
                </div>
            </agpr-tab>

            @if (agentSummary?.id && (mode === agentWidgetMode.edit)) {
                <agpr-tab
                    [id]="'replayHistory'"
                    icon="fa-clock-rotate-left fa-md"
                    [tooltip]="'Social.agentWidget.replay.history'"
                >
                    <div
                        class="rhp-estimateContainer"
                        [agprLoading]="loadingEstimate"

                    >
                        <agpr-scroll-panel class="rhp-scrollPanel">

                            <agpr-agent-history
                                #agentHistory
                                [agentId]="agentSummary.id"
                            ></agpr-agent-history>
                        </agpr-scroll-panel>
                    </div>
                </agpr-tab>
            }
        </agpr-right-sidebar>
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '.cancelButton'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="handleCancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>

        @if (settingUpReplay) {
            <agpr-button
                [id]="id + '.startReplayButton'"
                label="Social.agentWidget.replay.startButton"
                [style]="buttonTypes.primary"
                [disabled]="(agentForm.enabled && !agentForm.valid) || !containX || onlyNotKeywords || isQuotaExceeded"
                [tooltip]="
                    isQuotaExceeded ? 'Social.agentWidget.replay.quotaExceed' :
                    !containX ? 'Social.agentWidget.replay.onlyX' :
                    onlyNotKeywords ? 'Social.agentWidget.replay.positiveKeywords' : ''"
                (click)="startReplay()"
            ></agpr-button>
        } @else {
            @if (containX) {
                @if (!isDirty && (mode === agentWidgetMode.edit)) {
                    <agpr-button
                        [id]="id + '.setupReplayButton'"
                        label="Social.agentWidget.replay.button"
                        [disabled]="!agentForm.valid || onlyNotKeywords || isQuotaExceeded"
                        [tooltip]="
                            isQuotaExceeded ? 'Social.agentWidget.replay.quotaExceed' :
                            !containX ? 'Social.agentWidget.replay.onlyX' :
                            onlyNotKeywords ? 'Social.agentWidget.replay.positiveKeywords' : ''"
                        [style]="buttonTypes.primaryB"
                        (click)="setupReplay()"
                    ></agpr-button>
                } @else if (isDirty || !agent?.id) {
                    <div class="agpr-agentWidget-replay-after">
                        <agpr-checkbox
                            [id]="id + '_setupReplayAfter'"
                            label="Social.agentWidget.replay.buttonNext"
                            [ngModelOptions]="{standalone: true}"
                            [infoCircleTooltip]="
                                isQuotaExceeded ? 'Social.agentWidget.replay.quotaExceed' :
                                !containX ? 'Social.agentWidget.replay.onlyX' :
                                onlyNotKeywords ? 'Social.agentWidget.replay.positiveKeywords' : 'Social.agentWidget.replay.buttonNext.info'"
                            [tooltipPosition]="'top'"
                            [binary]="true"
                            [disabled]="onlyNotKeywords || isQuotaExceeded"
                            [(ngModel)]="setUpReplayAfter"
                            (onChange)="handleSetUpReplayAfter($event)"
                        ></agpr-checkbox>
                    </div>
                }
            }

            <agpr-button
                *ngIf="mode === agentWidgetMode.create"
                [id]="id + '.createTopicButton'"
                label="Social.agentWidget.button.create"
                [disabled]="!agentForm.valid"
                [tooltip]="saveErrorTooltip"
                tooltipPosition="top"
                [style]="buttonTypes.primary"
                (click)="save()"
            ></agpr-button>
            <agpr-split-button
                *ngIf="mode === agentWidgetMode.edit"
                [id]="id + '.saveTopicButton'"
                label="Social.agentWidget.button.save"
                [options]="saveActions"
                panelPositionY="top"
                panelPositionX="right"
                [style]="buttonTypes.primary"
                [caretDown]="false"
                [disabled]="!agentForm.valid"
                [tooltip]="saveErrorTooltip"
                tooltipPosition="top"
            ></agpr-split-button>
        }
    </ng-template>
</agpr-take-over-panel>
